import { useCallback, useEffect, useRef, useState } from 'react';
import { consultarCaixaSis } from '../../../../api/caixaSis';
export function useCaixaSisConsulta(uuid) {
    const existe = Boolean(uuid && uuid !== 'null');
    const [state, setState] = useState({ uuid: null, data: null, erro: null, carregando: false });
    const sequencia = useRef(0);
    const atualizar = useCallback(async () => {
        if (!uuid || uuid === 'null') return;
        const atual = ++sequencia.current;
        setState((prev) => ({ uuid, data: prev.uuid === uuid ? prev.data : null, carregando: true, erro: null }));
        try {
            const data = await consultarCaixaSis(uuid);
            if (typeof data?.sis !== 'boolean') throw new Error('Resposta de identificação do caixa inválida.');
            if (atual === sequencia.current) setState({ uuid, data, erro: null, carregando: false });
            return data;
        } catch (e) {
            if (atual === sequencia.current) setState((prev) => ({ ...prev, uuid, erro: e.message, carregando: false }));
            throw e;
        }
    }, [uuid]);
    useEffect(() => {
        if (existe) atualizar().catch(() => {});
        return () => {
            sequencia.current += 1;
        };
    }, [existe, atualizar]);
    const corresponde = state.uuid === uuid;
    return {
        data: corresponde ? state.data : null,
        erro: corresponde ? state.erro : null,
        carregando: existe && (!corresponde || state.carregando || (!state.data && !state.erro)),
        atualizar,
    };
}
